var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeatGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 256.4",
    style: {
      enableBackground: "new 0 0 120 256.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BFBFBF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,0.1c-2.5-0.7-4.7,1.8-3.7,4.2c2.6,5.8,5.7,16.3,5.7,34c0,29.6-48.2,46.3-48.2,101 c0,42.5,34.8,57,50.2,61.4c2.5,0.7,4.7-1.8,3.7-4.2c-2.6-5.8-5.7-16.3-5.7-34c0-29.6,48.2-46.3,48.2-101 C108.2,18.9,73.4,4.4,57.9,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117,256.4H3c-1.7,0-3-1.3-3-3v-26c0-1.7,1.3-3,3-3h114c1.7,0,3,1.3,3,3v26C120,255,118.7,256.4,117,256.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeatGrey);
export default __webpack_public_path__ + "static/media/icon-heat_grey.82d7d0a43bd9a89a8fdd184d90ec339e.svg";
export { ForwardRef as ReactComponent };